import { gql } from '@apollo/client';

export const PATCH_CERTIFICATE_TEMPLATE_OVERRIDE = gql`
    mutation PatchCertificateTemplateOverride($input: PatchCertificateTemplateOverrideInput!) {
        result: patchCertificateTemplateOverride(input: $input) { 
            id
            name
            description
            certificateTemplateId
            templateKey
            segments
            weight
            certificateTemplateOverrideUrl
            createdAt
            updatedAt
        }
    }
`;

